import axios from 'axios';

export const reportApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/report`,
    headers: {
        'Content-Type': 'application/json'
    }
})